'use client';

import { useEffect, useRef } from 'react';
import { I18nextProvider } from 'react-i18next';
import initTranslations from '../i18n/translations';
import { createInstance, type i18n as I18nInstance } from 'i18next';

export default function TranslationsProvider({ children, locale, namespaces, resources }) {
  const i18nRef = useRef<I18nInstance | null>(null);

  if (!i18nRef.current) {
    i18nRef.current = createInstance();
    initTranslations(locale, namespaces, i18nRef.current, resources);
  }

  useEffect(() => {
    if (!resources || !locale || !namespaces?.length || !i18nRef.current) {
      return;
    }

    for (const namespace of namespaces) {
      if (resources[locale]?.[namespace]) {
        i18nRef.current.addResourceBundle(locale, namespace, resources[locale][namespace], true, true);
      }
    }

    if (i18nRef.current.language !== locale) {
      void i18nRef.current.changeLanguage(locale);
    }
  }, [locale, namespaces, resources]);

  return <I18nextProvider i18n={i18nRef.current}>{children}</I18nextProvider>;
}
